<template>
    <rkm-overlay>
        <rkm-layout-body title="Cadastro de entrada">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
                
                <rkm-button
                    v-if="additionals && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        
            <rkm-layout-content>
                <Form
                    @loaded="habdleLoaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/imunizacao/entrada/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    data: () => ({
        additionals: null,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        habdleLoaded(object) {
            this.additionals = object.additionals

            if (this.additionals && this.additionals.salaVacinacaoLogada && !!this.additionals.salaVacinacaoLogada.id) {
                this.setShowExitFormConfirmation()
            }
        },
        handleExit() {
            this.$router.push({ name: 'imunizacao-entrada-index' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
    },
}
</script>